import React, { useContext, useState, useEffect, useRef } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListReturnBookPrint from "./ListReturnBookPrint"; 
import { 
  SelectStudent, 
  SelectWarehouse,
} from "../Include/DynamicSelect";

import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"; 
import { CREATE_STUDENT_RETURN_RENT_MATERIAL } from "../../Schema/StudentRent";
import { useReactToPrint } from "react-to-print";

export default function PrintRentMaterial({ open, handleClose, setRefetch , editData }) {
  //
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [studentVal, setStudentVal] = useState({ id: "", title: "" }); 
  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" }); 
  const [requiredField, setRequiredField] = useState(false); 

  const handleGetTranslate = (string) => {
      if(string === "not_yet_returned") {
          return "មិនទាន់ប្រគល់"
      }
      if(string === "lose_some") {
          return "បាត់"
      }
      if(string === "return_some") {
          return "ប្រគល់ខ្លះ"
      }
      if(string === "return") {
          return "ប្រគល់អស់"
      }  
      return string
  }
  
  // =============== List Item Set ===================
  const book = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    condition: "",
    returnMaterial: [],
    key: Date.now() + Math.random(),
  }; 

  const [bookList, setBookList] = useState([book]); 

  const handleAddListBook = () => {
    setBookList([...bookList, book]);
  };

  const handleAddListSubBook = (mainKey) => { 
    //  
    const newBook = bookList?.map( (d) => {
      if(mainKey === d?.key) {        
        // 
        if(d.returnMaterial?.length > 0) {
          let newArray = d.returnMaterial;
          d.returnMaterial = [...newArray, {
            key: Date.now() + Math.random(),
            isOld: false,
            condition: "",
            qty: 0,
            desc: "", 
            warehouseId: { 
              id: "", 
              title: ""
            }, 
          }];
        } else {
          d.returnMaterial = [{
            key: Date.now() + Math.random(),
            isOld: false,
            condition: "",
            qty: 0,
            desc: "", 
            warehouseId: { 
              id: "", 
              title: ""
            }, 
          }];
        }       
      }
      return d;
    })
    setBookList(newBook);
  };

  const handleUpdateListBook = (key, val, fieldName) => {
    const newBook = bookList?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = val;
        } 
        if (key === d.key && fieldName === "qty") {
          d.qty = parseFloat(val);
        }
        if (key === d.key && fieldName === "condition") {
          d.condition = val;
        } 
      }
      return d;
    });
    setBookList(newBook);
  };


  const handleUpdateListSubBook = (key, subKey , val, fieldName) => {
    setRequiredField(false);
    // 
    const newBook = bookList?.map((d) => {       
      if(key === d?.key && d?.returnMaterial?.length > 0) {
                    
        d.returnMaterial = d?.returnMaterial?.map( (subReturn) => {
            if( subReturn?.key === subKey && fieldName === "condition" ) {
              subReturn.condition = val;
            }
            if( subReturn?.key === subKey && fieldName === "qty" ) {
              subReturn.qty = val;
            }
            if( subReturn?.key === subKey && fieldName === "warehouseId" ) { 
              subReturn.warehouseId = val || { id: "" , title: "" };
            }            
            return subReturn;
        })       
        
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleDeleteListBook = (key) => {
    const handleDeleteList = bookList?.filter((d) => d.key !== key);
    setBookList([...handleDeleteList]);
  };

  const handleDeleteSubList = (key,subKey) => {
    setRequiredField(false);
    // 
    const handleDeleteList = bookList?.filter((d) => {
      if(d.key === key) {
        d.returnMaterial = d?.returnMaterial?.filter((e) => e.key !== subKey);
      }
      return d;              
    });
    setBookList([...handleDeleteList]);
  };
  // ================== End List Item =================


  // ================= Function Create Student Book ===============
  const [createReturnRentMaterial] = useMutation(CREATE_STUDENT_RETURN_RENT_MATERIAL, {
    onCompleted: ({ createReturnRentMaterial }) => {
      setLoading(false);
      if (createReturnRentMaterial?.status) {
        setAlert(true, "success", createReturnRentMaterial?.message);
        handleClose();
        resetForm();
        setRefetch();
        setBookList([book]);
        setStudentVal({ id: "", title: "" }); 
        setWarehouseVal({ id: "", title: "" }); 
      } else {
        setAlert(true, "error", createReturnRentMaterial?.message);
        console.log("error");
      }
    },
    onError: (error) => {
      setLoading(false);
      console.log("error", error?.message);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    studentId: Yup.string().required("require!"),
    remark: Yup.string(), 
    returnDate: Yup.date().required("require!"),
    returnStatus: Yup.string().required("require!"),
    returnBy: Yup.string().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      studentId: "", 
      remark: "", 
      returnDate: new Date(),
      returnStatus: "",
      returnBy: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // 
      // console.log("bookList:::", bookList);
      // 
      let returnRentMaterialItemsToSubmit = [];        
      bookList?.map((d) => {
        if(d?.returnMaterial?.length > 0) { 
          d?.returnMaterial?.map( (row) => {
            // 
            if(row?.isOld === false) {
              returnRentMaterialItemsToSubmit.push({ 
                rentMaterialItemId: d?.rentMaterialItemId,
                warehouseId: row?.warehouseId?.id,
                condition: row?.condition, 
                qty: parseFloat(row?.qty || 0), 
                desc: "",
              })
            }              
          })  
        }  
      });

      // console.log("returnRentMaterialItemsToSubmit", returnRentMaterialItemsToSubmit);

      if(returnRentMaterialItemsToSubmit?.length === 0) {
        return 
      }

      // ============  Check Require Field  =============
      let createStatus = false;
      const BreakException = {};
      try {
        returnRentMaterialItemsToSubmit?.forEach(function (elem) { 
          if (
            elem?.rentMaterialItemId !== undefined &&
            elem?.rentMaterialItemId !== "" &&
            elem?.warehouseId !== undefined &&
            elem?.warehouseId !== "" &&
            elem?.qty >= 0 
          ) {             
            // console.log("true");
            createStatus = true;            
          } else {
            // console.log("false");
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      
      // 
      if (createStatus) { 
        // 
        setLoading(true);
        createReturnRentMaterial({
          variables: { 
            input: {
              desc: "",
              rentMaterialId: editData?._id,
              returnBy: values?.returnBy,
              returnDate: values?.returnDate,
              returnRentMaterialItems: returnRentMaterialItemsToSubmit,
            },
            inputRentMaterial: {
              desc: values?.remark,
              returnStatus: values?.returnStatus,
            } 
          },
        });

      }
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;
  
  //================== When Change Student ======================
  useEffect(() => {
    if (studentVal?.id) {
      setFieldValue("studentId", studentVal?.id); 
    } else {
      setFieldValue("studentId", "");
    }  
  }, [studentVal?.id, open]); 

  
  // 
  useEffect( () => {
    if(editData) {
      console.log(editData);
      setStudentVal({
        id: editData?.studentId?._id,
        title: editData?.studentId?.englishName+" - "+editData?.studentId?.lastName+" "+editData?.studentId?.firstName,
      })

      setFieldValue( "remark" , editData?.desc);
      setFieldValue( "returnStatus" , editData?.returnStatus);

      if(editData?.rentMaterialItems) {
        let listRentItem = [];
        editData?.rentMaterialItems?.map( (rowRent,index) => {
            // Find Return Item
            let returnMaterial = [];
 
            if(rowRent?.returnRentMaterialItems?.length > 0) {             
              rowRent?.returnRentMaterialItems?.map( (rowReturn,index) => {                   
                returnMaterial.push({    
                  key: index,           
                  isOld: true,   
                  returnBy: rowReturn?.returnRentMaterialId?.returnBy || "",
                  returnDate: rowReturn?.returnRentMaterialId?.returnDate || "",
                  condition: rowReturn?.condition,
                  qty: rowReturn?.qty,
                  desc: rowReturn?.desc, 
                  warehouseId: { 
                    id: rowReturn?.warehouseId?._id, 
                    title: rowReturn?.warehouseId?.warehouseName
                  }, 
                })
              })  
            }

            listRentItem.push({ 
              materialId: {
                id: rowRent?.listMaterialUnitId?.materialId?._id,
                title: rowRent?.listMaterialUnitId?.materialId?.materialEnName,               
                fullName: rowRent?.listMaterialUnitId?.materialId?.materialEnName,
              },
              listMaterialUnitId: {
                id: rowRent?.listMaterialUnitId?._id,
                title: rowRent?.listMaterialUnitId?.unitId?.unitKhName,
                imageSrc: rowRent?.listMaterialUnitId?.imageSrc,
              },
              rentMaterialItemId: rowRent?._id,
              returnMaterial: returnMaterial,
              qty: rowRent?.qty,
              condition: rowRent?.condition,
              key: Math.random() + index,
            })

        })
        setBookList(listRentItem);
      } 

    }
  },[editData , open])

  // console.log("bookList::::",bookList); 
  //print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
    
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ទទួលសម្ភារៈមកវិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Box mt={2} padding={2} className="body-container" ref={componentRef}>
              <Grid container rowSpacing={2} columnSpacing={3}>
                
                <Grid item xs={4}>
                  <Typography className="field-title">ឈ្មោះសិស្ស</Typography>
                  <TextField size="small" fullWidth value={studentVal?.title} />
                  {/* <SelectStudent
                    selectedVal={studentVal}
                    setSelectedVal={setStudentVal}
                    disabled={true}
                  /> */}
                  {!!errors.studentId && touched.studentId && (
                    <FormHelperText errorid="outlined-adornment-password">
                      {errors.studentId}
                    </FormHelperText>
                  )}
                </Grid>   

                {/* <Grid item xs={4}> */}
                  {/* <Typography className="field-title">កាលបរិច្ចេទប្រគល់</Typography> */}
                  {/* <TextField size="small" fullWidth value={moment(values?.returnDate)?.format("DD/MM/YYYY")} /> */}
                  {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      disabled
                      sx={{ width: "100%" }}
                      value={values?.returnDate}
                      onChange={(newValue) => {
                        setFieldValue("returnDate", newValue);
                      }}                      
                      className="search-field"
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                        },
                      }}
                      renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                      )}
                    />
                  </LocalizationProvider> */}
                {/* </Grid>  */}
                
                <Grid item xs={4}>
                  <Typography className="field-title">ស្ថានភាពបច្ចុប្បន្ន</Typography>
                  
                  <TextField size="small" fullWidth value={handleGetTranslate(values?.returnStatus)} />
                  {/* <FormControl fullWidth size="small" className="search-field">
                    <Select
                      value={values?.returnStatus}
                      onChange={(val) =>
                        setFieldValue( "returnStatus" , val.target.value )
                      } 
                      disabled
                    >
                      <MenuItem value="not_yet_returned">មិនទាន់ប្រគល់</MenuItem> 
                      <MenuItem value="lose_some">បាត់</MenuItem>
                      <MenuItem value="return_some">ប្រគល់ខ្លះ</MenuItem>
                      <MenuItem value="return">ប្រគល់អស់</MenuItem>
                    </Select>
                  </FormControl> */}
                </Grid>               
  
                <Grid item xs={12}>
                  <ListReturnBookPrint
                    handleDeleteList={handleDeleteListBook}
                    handleDeleteSubList={handleDeleteSubList}
                    handleUpdateList={handleUpdateListBook}
                    handleUpdateListSubBook={handleUpdateListSubBook}
                    handleAddList={handleAddListBook}
                    handleAddListSubBook={handleAddListSubBook}
                    warehouseId={warehouseVal?.id}
                    requiredField={requiredField}
                    bookList={bookList}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className="field-title">កំណត់សម្គាល់</Typography>
                  <TextField
                    className="text-field"
                    fullWidth
                    multiline
                    rows={2}
                    size="small"
                    placeholder="" 
                    value={values.remark}
                  />
                </Grid> 
                
              </Grid>  
            </Box>

            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  កំពុងដំណើរការ...
                </Button>
              ) : (
                <Button
                  className="btn-create"
                  fullWidth
                  onClick={handlePrint}
                >
                  Print
                </Button>
              )}
            </Grid> 

          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
